import * as urls from '../../src/common/urls';
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const StripeLinkRedirectComponent = () => {
    const query = useQuery();
    const saleId = query.get("saleId");

    useEffect(() => {
        const fetchAndRedirect = async () => {
            if (!saleId) {
                console.error("No saleId provided in URL");
                return;
            }

            try {
                const response = await fetch(urls.GetStripePaymentLink_URL, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ saleId }),
                });

        if (!response.ok) {
            const errorText = await response.text(); 
            throw new Error(`Failed to fetch the link: ${errorText}`);
        }

        const data = await response.json();

        if (data.link) {
            window.location.href = data.link;
        }
            } catch (error) {
                console.error("Error fetching link:", error);
            }
        };

        fetchAndRedirect();
    }, [saleId]);

    return <p>Redirecting...</p>;
};

export default StripeLinkRedirectComponent;
